import { user as initialState } from '../initialState.tsx';
import {
    REQUEST_USER_LOGIN,
    REQUEST_USER_PROFILE,
    RECEIVE_USER_LOGIN,
    RECEIVE_USER_PROFILE,
    ERROR_USER_LOGIN,
    ERROR_USER_PROFILE,
    REQUEST_USER_LOGOUT,
    RECEIVE_CHANGE_PASSWORD,
    RECEIVE_USER_PROFILE_UPDATE,
    REQUEST_MAINTENANCE_CARDS,
    RECEIVE_MAINTENANCE_CARDS,
    ERROR_MAINTENANCE_CARDS,
    REQUEST_CLOCK_IN,
    RECEIVE_CLOCK_IN,
    ERROR_CLOCK_IN,
    REQUEST_CLOCK_OUT,
    RECEIVE_CLOCK_OUT,
    ERROR_CLOCK_OUT,
    REQUEST_CURRENT_CLOCK,
    RECEIVE_CURRENT_CLOCK,
    ERROR_CURRENT_CLOCK,
    REQUEST_INTERNET_USER_LIST,
    RECEIVE_INTERNET_USER_LIST,
    ERROR_INTERNET_USER_LIST,
    REQUEST_LOGIN_STATISTICS,
    RECEIVE_LOGIN_STATISTICS,
    ERROR_LOGIN_STATISTICS,
    REQUEST_USER_INFO,
    RECEIVE_USER_INFO,
    ERROR_USER_INFO,
    CLEAR_INTERNET_USER,
    REQUEST_ALL_CUSTOMERS,
    RECEIVE_ALL_CUSTOMERS,
    ERROR_ALL_CUSTOMERS,
    REQUEST_ALL_SURVEYTYPES,
    RECEIVE_ALL_SURVEYTYPES,
    ERROR_ALL_SURVEYTYPES,
    REQUEST_ADD_COMPANY,
    RECEIVE_ADD_COMPANY,
    ERROR_ADD_COMPANY,
    REQUEST_DELETE_COMPANY,
    RECEIVE_DELETE_COMPANY,
    ERROR_DELETE_COMPANY,
    REQUEST_ADD_AGENCY,
    RECEIVE_ADD_AGENCY,
    ERROR_ADD_AGENCY,
    REQUEST_DELETE_AGENCY,
    RECEIVE_DELETE_AGENCY,
    ERROR_DELETE_AGENCY,
    REQUEST_ALL_RIGHTS,
    RECEIVE_ALL_RIGHTS,
    ERROR_ALL_RIGHTS,
    REQUEST_ADD_RIGHT,
    RECEIVE_ADD_RIGHT,
    ERROR_ADD_RIGHT,
    REQUEST_DELETE_RIGHT,
    RECEIVE_DELETE_RIGHT,
    ERROR_DELETE_RIGHT,
    REQUEST_ALL_ROLES,
    RECEIVE_ALL_ROLES,
    ERROR_ALL_ROLES,
    REQUEST_ALL_MAJOR_COMPANIES,
    RECEIVE_ALL_MAJOR_COMPANIES,
    ERROR_ALL_MAJOR_COMPANIES,
    REQUEST_TIMECLOCK_PAYPERIOD,
    RECEIVE_TIMECLOCK_PAYPERIOD,
    ERROR_TIMECLOCK_PAYPERIOD,
    REQUEST_ADD_TIMECLOCK,
    RECEIVE_ADD_TIMECLOCK,
    ERROR_ADD_TIMECLOCK,
    REQUEST_DELETE_TIMECLOCK,
    RECEIVE_DELETE_TIMECLOCK,
    ERROR_DELETE_TIMECLOCK,
    REQUEST_UPDATE_TIMECLOCK,
    RECEIVE_UPDATE_TIMECLOCK,
    ERROR_UPDATE_TIMECLOCK,
    REQUEST_EMPLOYEES_BY_PAYPERIOD,
    RECEIVE_EMPLOYEES_BY_PAYPERIOD,
    CLEAR_EMPLOYEES_BY_PAYPERIOD,
    ERROR_EMPLOYEES_BY_PAYPERIOD,
    REQUEST_APPROVE_USER_PAYPERIOD,
    RECEIVE_APPROVE_USER_PAYPERIOD,
    ERROR_APPROVE_USER_PAYPERIOD,
    REQUEST_EMPLOYEE_DETAILS,
    RECEIVE_EMPLOYEE_DETAILS,
    ERROR_EMPLOYEE_DETAILS,
    REQUEST_UPDATE_USER,
    RECEIVE_UPDATE_USER,
    ERROR_UPDATE_USER,
    REQUEST_CREATE_USER,
    RECEIVE_CREATE_USER,
    ERROR_CREATE_USER,
    CLEAR_USER_REDIRECT,
    REQUEST_DISABLE_USER,
    RECEIVE_DISABLE_USER,
    ERROR_DISABLE_USER,
    USER_WILL_LOGOUT,
    SET_MIDNIGHT,

    REQUEST_TRAINING_SECTIONS,
    RECEIVE_TRAINING_SECTIONS,
    ERROR_TRAINING_SECTIONS,

    REQUEST_GET_UNDERWRITERS,
    RECEIVE_GET_UNDERWRITERS,
    ERROR_GET_UNDERWRITERS,

    REQUEST_GET_AUTHORIZED_UNDERWRITERS,
    RECEIVE_GET_AUTHORIZED_UNDERWRITERS,
    ERROR_GET_AUTHORIZED_UNDERWRITERS,

    REQUEST_ADD_INTERNET_USER,
    RECEIVE_ADD_INTERNET_USER,
    ERROR_ADD__INTERNET_USER,

    REQUEST_REMOVE_INTERNET_USER,
    RECEIVE_REMOVE_INTERNET_USER,
    ERROR_REMOVE_INTERNET_USER,
    REQUEST_QA_EMPLOYEES_BY_PAYPERIOD,
    RECEIVE_QA_EMPLOYEES_BY_PAYPERIOD,
    CLEAR_QA_EMPLOYEES_BY_PAYPERIOD,
    ERROR_QA_EMPLOYEES_BY_PAYPERIOD,
} from 'typeConstants';
import { RECEIVE_USER_LOGOUT } from '../../typeConstants';
import { stringComparisonOrdinalCaseInsensitive } from '../../tools/sortComparisons';

const user = (state = initialState, action) => {

    switch (action.type) {
        // Reset transient state on rehydration to prevent infinite spinner on login page
        // when isFetching/triedLogin were persisted as true before page reload
        case 'persist/REHYDRATE':
            return {
                ...state,
                ...action.payload?.user,
                isFetching: false,
                triedLogin: false,
            };
        case REQUEST_USER_LOGIN:
        case REQUEST_USER_PROFILE:
            {
                let searchParams = new URLSearchParams(window.location.search);
                return {
                    ...state,
                    isFetching: true,
                    triedLogin: true,
                    // read the return url from ?ReturnUrl query string parameter and store it for later
                    // SD-19067 - this was never working in the first place, likely because the parameter is redirect and not ReturnUrl, but i kept a legacy check for ReturnUrl here because i dont know if any links exist out there using it
                    returnUrl: searchParams.get("redirect") || searchParams.get("ReturnUrl"),
                    willLogOut: false,
                };
            }
        case RECEIVE_USER_LOGIN:
        case RECEIVE_USER_PROFILE:
            if (action.payload) {
                return {
                    ...state,
                    redirect: action.payload.redirect || {},
                    profile: action.payload.profile || action.payload,
                    isFetching: false
                };
            }
            return state;
        case REQUEST_USER_LOGOUT:
        case RECEIVE_USER_LOGOUT:
        case RECEIVE_CHANGE_PASSWORD:
        case RECEIVE_USER_PROFILE_UPDATE:
            return {
                ...state,
                redirect: {},
                profile: {},
                returnUrl: "",
            };
        case ERROR_USER_LOGIN:
        case ERROR_USER_PROFILE:
            return {
                ...state,
                redirect: {},
                isFetching: false
            };
        case CLEAR_USER_REDIRECT:
            return {
                ...state,
                returnUrl: "",
                redirect: {}
            };
        case REQUEST_MAINTENANCE_CARDS:
            return {
                ...state,
                isFetchingMaintenanceSections: true
            };
        case RECEIVE_MAINTENANCE_CARDS:
            return {
                ...state,
                maintenanceSections: action.payload,
                isFetchingMaintenanceSections: false
            };
        case ERROR_MAINTENANCE_CARDS:
            return {
                ...state,
                isFetchingMaintenanceSections: false
            };
        case REQUEST_CLOCK_IN:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_CLOCK_IN:
            return {
                ...state,
                activeClock: action.payload,
                updatingUser: false,
            };
        case ERROR_CLOCK_IN:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_CLOCK_OUT:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_CLOCK_OUT:
            return {
                ...state,
                activeClock: action.payload,
                updatingUser: false,
            };
        case ERROR_CLOCK_OUT:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_CURRENT_CLOCK:
            return {
                ...state,
                isFetchingActiveClock: true,
            };
        case RECEIVE_CURRENT_CLOCK:
            return {
                ...state,
                activeClock: action.payload,
                isFetchingActiveClock: false,
            };
        case ERROR_CURRENT_CLOCK:
            return {
                ...state,
                isFetchingActiveClock: false,
            };
        case REQUEST_INTERNET_USER_LIST:
            return {
                ...state,
                isFetchingInternetUserList: true
            };
        case RECEIVE_INTERNET_USER_LIST:
            return {
                ...state,
                internetUserList: action.payload,
                isFetchingInternetUserList: false
            };
        case ERROR_INTERNET_USER_LIST:
            return {
                ...state,
                isFetchingInternetUserList: false
            };


        case REQUEST_LOGIN_STATISTICS:
            return {
                ...state,
                internetUserId: action.payload,
                isFetchingLoginStatistics: true
            };
        case RECEIVE_LOGIN_STATISTICS:
            return {
                ...state,
                loginStatistics: action.payload,
                isFetchingLoginStatistics: false
            };
        case ERROR_LOGIN_STATISTICS:
            return {
                ...state,
                isFetchingLoginStatistics: false
            };
        case REQUEST_USER_INFO:
            return {
                ...state,
                isFetchingInternetUser: true
            };
        case RECEIVE_USER_INFO:
            return {
                ...state,
                internetUser: action.payload,
                isFetchingInternetUser: false
            };
        case ERROR_USER_INFO:
            return {
                ...state,
                isFetchingInternetUser: false
            };
        case CLEAR_INTERNET_USER:
            return {
                ...state,
                internetUser: {},
                isFetchingInternetUser: true,
            };
        case REQUEST_ALL_CUSTOMERS:
            return {
                ...state,
                isFetchingAllCustomersList: true,
            };
        case RECEIVE_ALL_CUSTOMERS:
            return {
                ...state,
                allCustomers: action.payload,
                isFetchingAllCustomersList: false,
            };
        case ERROR_ALL_CUSTOMERS:
            return {
                ...state,
                isFetchingAllCustomersList: false,
            };
        case REQUEST_ALL_SURVEYTYPES:
            return {
                ...state,
                isFetchingAllSurveyTypesList: true,
            };
        case RECEIVE_ALL_SURVEYTYPES:
            return {
                ...state,
                allSurveyTypes: action.payload,
                isFetchingAllSurveyTypesList: false,
            };
        case ERROR_ALL_SURVEYTYPES:
            return {
                ...state,
                isFetchingAllSurveyTypesList: false,
            };

        case REQUEST_ADD_COMPANY:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_ADD_COMPANY:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_ADD_COMPANY:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_DELETE_COMPANY:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_DELETE_COMPANY:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_DELETE_COMPANY:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_ADD_AGENCY:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_ADD_AGENCY:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_ADD_AGENCY:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_DELETE_AGENCY:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_DELETE_AGENCY:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_DELETE_AGENCY:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_ALL_RIGHTS:
            return {
                ...state,
                isFetchingAllrightsList: true,
            };
        case RECEIVE_ALL_RIGHTS: {
            // Transform rights array into MSelect-compatible format { value, label }
            const rightsFormatted = Array.isArray(action.payload) 
                ? action.payload.map(right => typeof right === 'string' 
                    ? { value: right, label: right } 
                    : right)
                : action.payload;
            return {
                ...state,
                allRights: rightsFormatted,
                isFetchingAllRightsList: false,
            };
        }
        case ERROR_ALL_RIGHTS:
            return {
                ...state,
                isFetchingAllRightsList: false,
            };
        case REQUEST_ADD_RIGHT:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_ADD_RIGHT:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_ADD_RIGHT:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_DELETE_RIGHT:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_DELETE_RIGHT:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_DELETE_RIGHT:
            return {
                ...state,
                updatingUser: false,
            };

        case REQUEST_ALL_ROLES:
            return {
                ...state,
                isFetchingAllRolesList: true,
            };
        case RECEIVE_ALL_ROLES:
            return {
                ...state,
                allRoles: action.payload,
                isFetchingAllRolesList: false,
            };
        case ERROR_ALL_ROLES:
            return {
                ...state,
                isFetchingAllRolesList: false,
            };

        case REQUEST_ALL_MAJOR_COMPANIES:
            return {
                ...state,
                isFetchingAllMajorCompanies: true,
            };
        case RECEIVE_ALL_MAJOR_COMPANIES: {
            let sortedMajorCompanies = action.payload;
            if (action.payload.length) {
                sortedMajorCompanies = sortedMajorCompanies.sort(stringComparisonOrdinalCaseInsensitive);
            }
            return {
                ...state,
                allMajorCompanies: sortedMajorCompanies,
                isFetchingAllMajorCompanies: false,
            };
        }
        case ERROR_ALL_MAJOR_COMPANIES:
            return {
                ...state,
                isFetchingAllMajorCompanies: false,
            };
        case REQUEST_UPDATE_USER:
            return {
                ...state,
                updatingUserInfo: true,
            };
        case RECEIVE_UPDATE_USER:
            return {
                ...state,
                updatingUserInfo: false,
            };
        case ERROR_UPDATE_USER:
            return {
                ...state,
                updatingUserInfo: false,
            };
        case REQUEST_TIMECLOCK_PAYPERIOD:
            return {
                ...state,
                isFetchingTimeClockByPayPeriod: true,
            };
        case RECEIVE_TIMECLOCK_PAYPERIOD:
            return {
                ...state,
                timeClockByPayPeriod: action.payload,
                isFetchingTimeClockByPayPeriod: false
            };
        case ERROR_TIMECLOCK_PAYPERIOD:
            return {
                ...state,
                isFetchingTimeClockByPayPeriod: false,
            };
        case REQUEST_ADD_TIMECLOCK:
            return {
                ...state,
                isAddingTimeClock: true,
            };
        case RECEIVE_ADD_TIMECLOCK:
            return {
                ...state,
                isAddingTimeClock: false,
            };
        case ERROR_ADD_TIMECLOCK:
            return {
                ...state,
                isAddingTimeClock: false,
            };
        case REQUEST_DELETE_TIMECLOCK:
            return {
                ...state,
                isDeletingTimeClock: true,
            };
        case RECEIVE_DELETE_TIMECLOCK:
            return {
                ...state,
                isDeletingTimeClock: false,
            };
        case ERROR_DELETE_TIMECLOCK:
            return {
                ...state,
                isDeletingTimeClock: false,
            };
        case REQUEST_UPDATE_TIMECLOCK:
            return {
                ...state,
                isUpdatingTimeClock: true,
            };
        case RECEIVE_UPDATE_TIMECLOCK:
            return {
                ...state,
                isUpdatingTimeClock: false,
            };
        case ERROR_UPDATE_TIMECLOCK:
            return {
                ...state,
                isUpdatingTimeClock: false,
            };
        case REQUEST_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: true,
            };
        case RECEIVE_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: false,
                employees: action.payload
            };
        case CLEAR_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: false,
                employees: []
            };
        case ERROR_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: false,
            };
        case REQUEST_APPROVE_USER_PAYPERIOD:
            return {
                ...state,
                isApprovingPayPeriod: true,
            };
        case RECEIVE_APPROVE_USER_PAYPERIOD:
            return {
                ...state,
                isApprovingPayPeriod: false,
            };
        case ERROR_APPROVE_USER_PAYPERIOD:
            return {
                ...state,
                isApprovingPayPeriod: false,
            };
        case REQUEST_EMPLOYEE_DETAILS:
            return {
                ...state,
                isFetchingEmployeeDetails: true,
            };
        case RECEIVE_EMPLOYEE_DETAILS:
            return {
                ...state,
                employeeDetails: action.payload,
                isFetchingEmployeeDetails: false,
            };
        case ERROR_EMPLOYEE_DETAILS:
            return {
                ...state,
                isFetchingEmployeeDetails: false,
            };
        case REQUEST_CREATE_USER:
            return {
                ...state,
                internetUser: {},
                isCreatingUser: true
            };
        case RECEIVE_CREATE_USER:
            return {
                ...state,
                internetUser: action.payload,
                isCreatingUser: false,
            };
        case ERROR_CREATE_USER:
            return {
                ...state,
                internetUser: {},
                isCreatingUser: false,
            };
        case REQUEST_DISABLE_USER:
            return {
                ...state,
                updatingUserInfo: true,
            };
        case RECEIVE_DISABLE_USER:
            return {
                ...state,
                updatingUserInfo: false,
            };
        case ERROR_DISABLE_USER:
            return {
                ...state,
                updatingUserInfo: false,
            };
        case USER_WILL_LOGOUT:
            return {
                ...state,
                willLogOut: true,
            };
        case SET_MIDNIGHT:
            return {
                ...state,
                midnight: action.payload,
            };
        case REQUEST_TRAINING_SECTIONS:
            return {
                ...state,
                fetchingTrainingSections: true,
            };
        case RECEIVE_TRAINING_SECTIONS:
            return {
                ...state,
                fetchingTrainingSections: false,
                trainingSections: action.payload,
            };
        case ERROR_TRAINING_SECTIONS:
            return {
                ...state,
                fetchingTrainingSections: false,
            };
        case REQUEST_GET_UNDERWRITERS:
            return {
                ...state,
                isFetchingUnderwriters: true,
            };
        case RECEIVE_GET_UNDERWRITERS:
            return {
                ...state,
                userUnderwriters: action.payload,
                isFetchingUnderwriters: false,
            };
        case ERROR_GET_UNDERWRITERS:
            return {
                ...state,
                isFetchingUnderwriters: false,
            };
        case REQUEST_GET_AUTHORIZED_UNDERWRITERS:
            return {
                ...state,
                isFetchingAuthorizedUnderwriters: true,
            };
        case RECEIVE_GET_AUTHORIZED_UNDERWRITERS:
            return {
                ...state,
                authorizedUnderwriters: action.payload,
                isFetchingAuthorizedUnderwriters: false,
            };
        case ERROR_GET_AUTHORIZED_UNDERWRITERS:
            return {
                ...state,
                isFetchingAuthorizedUnderwriters: false,
            };
        case REQUEST_ADD_INTERNET_USER:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_ADD_INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_ADD__INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_REMOVE_INTERNET_USER:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_REMOVE_INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_REMOVE_INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_QA_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: true,
            };
        case RECEIVE_QA_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: false,
                employees: action.payload
            };
        case CLEAR_QA_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: false,
                employees: []
            };
        case ERROR_QA_EMPLOYEES_BY_PAYPERIOD:
            return {
                ...state,
                isFetchingEmployees: false,
            };
        default:
            return state;
    }
};

export default user;
